var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['home', _vm.user ? 'logged-in' : '']},[(_vm.user)?_c('shelf'):_vm._e(),_c('intro',{attrs:{"active-category":_vm.activeCategory,"active-root-category":_vm.activeRootCategory,"categories":_vm.activeCategories}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }